import "./style.scss";
import { Carousel, Slide } from "vue-carousel";

var app = new Vue({
  el: "#js-dress",
  data: {
    displayDressNum: -1,
  },
  components: {
    Carousel,
    Slide,
  },
  methods: {
    toggleModal(num) {
      if (this.displayDressNum != num) {
        this.displayDressNum = num;
      } else {
        this.displayDressNum = -1;
      }
    },
  },
});
